import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { enc, SHA512 } from 'crypto-js';
import { AppService } from '../../services/services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/services/encryption.service';
import { ErrorModalComponent } from 'src/app/common/error-modal/error-modal.component';

@Component({
    selector: 'nri-app-passport',
    templateUrl: './passport-details.component.html',
    styleUrls: ['./passport-details.component.scss']
  })

export class PassportDetailsComponent implements OnInit{
  @ViewChild('passportimg1') passportimg1Error: ElementRef;
  @ViewChild('passportimg2') passportimg2Error: ElementRef;
 public occupation: string = '';
 public country: string = '';
 public options:  INgxMyDpOptions = {
  dateFormat: 'dd/mm/yyyy',
};
public defaultMonth: IMyDefaultMonth = {
  defMonth: ''
};
passportForm = this.formBuilder.group({
  // 'AnnualIncome': ['',Validators.required],
  'Gender': ['',Validators.required],
  'POIOCI': ['N',Validators.required],
  'MaritalStatus': ['',Validators.required],
  'Nationality': ['',Validators.required],
  // 'Occupation': ['',Validators.required],
  'PassportName': ['', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator]],
  'PassportNo': ['', Validators.required],
  'PassportExpiry': ['',Validators.required],
  'dateOfIssue' :[null , Validators.required],
  'Placeofbirth': ['', Validators.required],
  'PlaceOfIssue': ['', Validators.required],
  'IndianContact' : ['']
});
erefNo: string = '';
occupationList: any = '';
incomeList: any = '';
formSubmit: boolean;
passport1Updt: boolean;
passport2Updt: boolean;
passport1Imgempty: boolean;
passport2Imgempty: boolean;
passportExpiry: any;
countryList: any;
countryName: any;
sixMonthDate:any;
expiryDateError: boolean = false;
@ViewChild('errorComp') errorComp : ErrorModalComponent;
alphanumericPattern = /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/;
passportype : boolean = true;
public dateOfIssueOptions:  INgxMyDpOptions = {
  dateFormat: 'dd/mm/yyyy',
};
dateOfIssues: string = "";
showIndianNumber : boolean = false;
contactError: boolean = false;
contactErrorMsg: string = "";
constructor(private router: Router, public formBuilder: FormBuilder,public _http: AppService, private toastr: ToastrService, private loader: NgxUiLoaderService,private cdRef: ChangeDetectorRef, private http:EncryptionService){
  this._http.getRefNum().subscribe(data=>{
    this.erefNo = data;
  });
  let ref = sessionStorage.getItem("AxNo");
  if(ref){
    this.erefNo = ref;
  }
}

 ngOnInit() {
  this._http.scroll();
  const d: Date = new Date();
  this.options = {
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
    disableUntil: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }
  }
  this.dateOfIssueOptions =  {
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
    disableSince: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() + 1}
  };

  this.countryList = this._http.countryList;

   this._http.getMasters().subscribe(data=>{
     if(data && data.OccupationList){
       this.occupationList = data.OccupationList
     }
     if(data && data.IncomeList){
       this.incomeList = data.IncomeList
     }
   });
   this.getPassportInfo();
 }

 openCalendarAndDetectChanges(dp: any) {
  dp.openCalendar();
  this.cdRef.detectChanges();
}

getOCR(event:any){
  console.log(event,"passport ocr");
  let ocrRead = event.data.BindingdataFront;
  let gender:string = "";
  let name:any = "";
  let number:any = "";
  let placeofBirth : string = "";
  let PlaceOfIssue : string = '';
  const indianRegex = /indian/gi;
  if(ocrRead) {
     gender = ocrRead.Gender ? ocrRead.Gender : "";
     name = ocrRead.NameOnCard ? ocrRead.NameOnCard : "";
     number = ocrRead.IdNumber ? ocrRead.IdNumber : "";
     placeofBirth = ocrRead.PlaceOfBirth ? ocrRead.PlaceOfBirth : "";
     PlaceOfIssue = ocrRead.PlaceOfIssue ? ocrRead.PlaceOfIssue : "";
  }
  this.countryList = this._http.countryList;
  if (ocrRead?.Nationality && indianRegex.test(ocrRead.Nationality)) {
    const country = this.countryList.filter((item:any) => {
      return item.Name === "India";
    })
    this.countryName = country[0].Name;
    this.passportForm.controls['Nationality'].setValue(country[0].Id);
    // this.showIndianNumber = true;
  }
  if(ocrRead){
    if(ocrRead.DateOfExpiry){
      this.dobChange(ocrRead.DateOfExpiry);
    }
    this.passportForm.patchValue({
      Gender: gender.toLowerCase() === "female" ? "F" : gender.toLowerCase() === "male" ? "M" : "",
      PassportName: name,
      PassportNo: number,
      Placeofbirth : placeofBirth,
      PlaceOfIssue : PlaceOfIssue
    })

    if (ocrRead.DateOfIssue) this.dateofIssueocrBind(ocrRead.DateOfIssue);
  }
}

indianNumCheck() {
  const regex = /^(?![6]{10}|[7]{10}|[8]{10}|[9]{10})[6-9]{1}[0-9]{9}$/;
  const number = this.passportForm.controls['IndianContact'].value;
  if (number && regex.test(number)) {
    this.contactError = false;
    this.contactErrorMsg = "";
  } else {
    this.contactError = true;
    this.contactErrorMsg = "Please Enter Valid Phone Number";
  }
}

dateIssueEvent(event:any) {
  this.dateOfIssues = event.formatted;
}

dobChange(expiry:string){
  let a = expiry;
  let d = new Date();
  let requiredDate= d.setMonth(d.getMonth() + 3);
  this.sixMonthDate = new Date(requiredDate);
  let selectedDate = new Date(a);
  if(this.sixMonthDate.getTime() > selectedDate.getTime()){
    this.expiryDateError = true;
  }else{
    this.expiryDateError = false;
  }
  let s = expiry.split(' ');
  let as = s[0].split('-'); 
  this.passportExpiry = `${as[2]}/${as[1]}/${as[0]}`;
  // this.passportExpiry = a[2];
  let exp:any = { date: { year: as[0], month: parseInt(as[1]), day: parseInt(as[2]) } };
  this.passportForm.patchValue({
    PassportExpiry:exp
  })

}

dateofIssueocrBind(issuedDate:string) {
  let s = issuedDate.split(' ');
  let as = s[0].split('-'); 
  this.dateOfIssues = `${as[2]}/${as[1]}/${as[0]}`;
  let doi:any = { date: { year: as[0], month: parseInt(as[1]), day: parseInt(as[2]) } };
  this.passportForm.patchValue({
    dateOfIssue:doi
  })
}


overallStatus(){
  let url = 'DIY/DIYOverallStatus';
  this.loader.start();
  let checkSum = this.erefNo;    
  let params = {
    'ReferenceNumber': this.erefNo,
  }
  this._http.httpPost(url,params, checkSum).subscribe({
    next: (data:any) => {
      this.loader.stop();
      if(data && data.IsSuccess){
        let item = data.overallLists;
      }

    },
    error: _error=>{
      this.loader.stop();
      // this.toastr.error(_error.error.Message)
      this.errorComp.ModalShow(_error.error.Message);
    }
  })
}


 getPassportInfo(){
    let url = "DIY/DIYGetPassportInfo";
    let checkSum = this.erefNo;
    let params = {
      "ReferenceNumber": this.erefNo
    }
    this.loader.start();
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let passportInfo = this.http.decryptUsingAES256(data.OutPut);
        if(passportInfo && passportInfo.IsSuccess){
          let exp:any;
          if(passportInfo.ExpairyDate){
            let a = passportInfo.ExpairyDate.split(' ');
            let d = a[0].split('/'); 
            this.passportExpiry = a[0];
             exp = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
          let dateOfIssue:any;
          if(passportInfo.DateOfIssue){
            let a = passportInfo.DateOfIssue.split(' ');
            let d = a[0].split('/'); 
            this.dateOfIssues = a[0];
              dateOfIssue = { date: { year: d[2], month: parseInt(d[1]), day: parseInt(d[0]) } };
          }
          if(passportInfo.POIOCI){
            this.passportype =true
          }
          this.passportForm.patchValue({
            // 'AnnualIncome': passportInfo.AnnualIncome,
            'Gender': passportInfo.Gender,
            'MaritalStatus': passportInfo.MaritalStatus,
            'Nationality': passportInfo.NationalityId,
            'POIOCI': passportInfo.POIOCI,
            // 'Occupation': passportInfo.Occupation,
            'PassportName': passportInfo.Name,
            'PassportNo': passportInfo.PassportNumber,
            'PassportExpiry': exp,
            'dateOfIssue' : dateOfIssue,
            'Placeofbirth': passportInfo.PlaceOfBirth,
            'PlaceOfIssue' : passportInfo.PlaceOfIssue,
            'IndianContact' : passportInfo.IndianMobileNumber
         });
         this.countryName = passportInfo.Nationality;
        //  if (this.countryName === "India") {
        //     this.showIndianNumber = true;
        //  } 
       
        }
      },error: _error=>{
        this.loader.stop();
        // this.toastr.error(_error.error.Message);
        this.errorComp.ModalShow(_error.error.Message);
      }
    })
 }


alphaNumeric(event: any) {
  const inputText = event.target.value;
  const sanitizedText = inputText.replace(/[^a-zA-Z0-9]/g, '');

  if (inputText !== sanitizedText) {
    event.target.value = sanitizedText;
  }
}

checkAlphanumeric(inputText: string): boolean {
  return this.alphanumericPattern.test(inputText);
}


 
public noWhitespaceValidator(control: FormControl) {
  return (control.value || '').trim().length? null : { 'whitespace': true };       
}


onInputChange(event: any) {
  const pattern = /^[a-zA-Z \b]+$/;
  const inputText = event.target.value;

  if (!pattern.test(inputText)) {
    // Remove invalid characters from the input value
    event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
  }
}

 spaceValidation(event:any, name: any){
  const input = event.target.value;
  event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
  if(name === 'PassportName'){
    this.passportForm.controls.PassportName.setValue(event.target.value);
  }
}

 onDateChanged(event:any){
  this.passportExpiry = event.formatted;
  let e = this.passportExpiry.split('/')
  let a = e[2]+'-'+e[1]+'-'+e[0];
  let d = new Date();
  let requiredDate= d.setMonth(d.getMonth() + 3);
  this.sixMonthDate = new Date(requiredDate);
  let selectedDate = new Date(a);
  if(this.sixMonthDate.getTime() > selectedDate.getTime()){
    this.expiryDateError = true;
  }else{
    this.expiryDateError = false;
  }
 }

 stageValidate(){
  const passportNoControl = this.passportForm.get('PassportNo');
  const inputText:any = passportNoControl?.value;

    if(inputText.length < 5){
      this.errorComp.ModalShow("Passport Number Should not be less than 5");
      return;
    }
    this.formSubmit = true;
    // const indianContact = this.passportForm.controls['IndianContact'].value;
    // if (this.showIndianNumber) {
    //   if (this.contactError) {
    //     return;
    //   }
    //   if (!indianContact) {
    //     this.contactError = true;
    //     this.contactErrorMsg = "Please Enter Phone Number";
    //     return;
    //   }
    //   this.contactError = false;
    //   this.contactErrorMsg = "";
    //   if (indianContact.length !== 10) {
    //     this.errorComp.ModalShow('Please enter valid Indian Contact Number');
    //     return;
    //   }
    // }
       let issueParts = this.dateOfIssues.split('/');
      let issueDate = new Date(+issueParts[2], +issueParts[1] - 1, +issueParts[0]);

      // --- Convert Expiry Date (dd/mm/yyyy) to Date ---
      let expiryParts = this.passportExpiry.split('/');
      let expiryDate = new Date(+expiryParts[2], +expiryParts[1] - 1, +expiryParts[0]);

      // Add 10 years to Issue Date
      const maxExpiry = new Date(issueDate);
      maxExpiry.setFullYear(issueDate.getFullYear() + 15);

      if (expiryDate > maxExpiry) {
        this.errorComp.ModalShow('Passport expiry date should not exceed 15 years.');
        return;
      }

      if(!this.passport1Updt){
        this.passport1Imgempty = true;
        this.errorComp.ModalShow('Please upload your passport front image');
      }
      else if(!this.passport2Updt){
        this.passport2Imgempty = true;
        this.errorComp.ModalShow('Please upload your passport back image');
      }else if(this.passportForm.controls.POIOCI.value === 'F' && this.countryName === "India"){
        this.errorComp.ModalShow('Nationality cannot be India when a Foreign Passport is selected. Please choose an appropriate nationality.');
        return
      }
      else if(this.passportForm.valid){
        let a:any = this.passportForm.controls.PassportNo.value;
        let b:any = this.passportForm.controls.PassportName.value;
        const checkSum = a.trim()+b.trim()+this.countryName+this.erefNo;
        this.loader.start();
        if(this.countryName === "India"){
          sessionStorage.setItem("passcount",this.countryName)
        }
        let params = {
          "PassportNumber": a.trim(),
          "Name": b.trim(), 
          "Nationality": this.countryName,
          "NationalityId": this.passportForm.controls.Nationality.value,
          "ExpairyDate": this.passportExpiry,
          "Gender": this.passportForm.controls.Gender.value,
          "MaritalStatus": this.passportForm.controls.MaritalStatus.value,
          'POIOCI': this.passportForm.controls.POIOCI.value,
          // "Occupation": this.passportForm.controls.Occupation.value,
          // "AnnualIncome": this.passportForm.controls.AnnualIncome.value,
          "ReferenceNumber": this.erefNo,
          "DateOfIssue" : this.dateOfIssues,
          'PlaceOfBirth' : this.passportForm.controls.Placeofbirth.value,
          'PlaceOfIssue' : this.passportForm.controls.PlaceOfIssue.value,
          'IndianMobileNumber' : this.passportForm.controls['IndianContact'].value
        }

        let url = "DIY/UpdatePassportInfo";
        this._http.httpPost(url,params, checkSum).subscribe({
          next: (data:any)=>{
          this.loader.stop();
          let updatePassport = this.http.decryptUsingAES256(data.OutPut);
          if(updatePassport && updatePassport.IsSuccess){
            if(this.passportForm.controls.POIOCI.value === 'F'){
              this._http.setOci('F');
              this.router.navigate(['/oci-pio'], { replaceUrl: true });
            }else{
               this._http.setOci('N');
              let a = this._http.getStatus().subscribe(data=>{
                this.router.navigate(['/foreign-address'], { replaceUrl: true });
              })
              a.unsubscribe();
            }
          }else{
            // this.toastr.error("Please try again.");
            this.errorComp.ModalShow("Please try again.");
          }
        },
        error: error=>{
          this.loader.stop();
          if(!window.navigator.onLine){
            // this.toastr.error("It appears that your internet connectivity is slow or please try again.")
            this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
          }else{
            // this.toastr.error(error.error.Message)
            this.errorComp.ModalShow(error.error.Message);
          }
        }
      });
      }
    // }
  }

  getCountryName(){
    let a:any = this.passportForm.controls.Nationality.value;
    let c = parseInt(a);
    let name = this.countryList.filter((e:any)=>{
      return e.Id === c;
    })
    this.countryName = name[0].Name;
    // if (this.countryName.toLowerCase() === "india") {
    //   this.showIndianNumber = true;
    // } else {
    //   this.showIndianNumber = false;
    // }
  }

  imageURL(event: any){
    if(event.name === "Passport1" && event.url){
    this.passport1Updt = true;
    this.passport1Imgempty = false;
    }
    else if(event.name === "Passport2" && event.url){
      this.passport2Updt = true;
      this.passport2Imgempty = false;
      }
  }

  backStage(){
    this.router.navigate(['/pan'], { replaceUrl: true });
  }
  onPassportTypeChange(event: any) {
  const selectedValue = event.target.value;
  if(selectedValue){
    this.passportype =true
  }
  
}
}